export const ADVISOR_ROUTING_PREFIX = 'advisor-'
export const PORTFOLIO_BUILDER = 'portfolio-builder'
export const MODEL_PORTFOLIO_BUILDER = `${PORTFOLIO_BUILDER}-model-portfolio`
export const PORTFOLIO_BUILDER_EDITOR = `${PORTFOLIO_BUILDER}-editor`
